import React, { Component } from 'react'
import { NavLink } from "react-router";
import Cookies from 'universal-cookie'
import './List.css'
import EditIcon from '../Icons/Edit.svg'
import InfoIcon from '../Icons/Info.svg'
import OpenIcon from '../Icons/Open.svg'
import PlayIcon from '../Icons/Play.svg'
import StopIcon from '../Icons/Stop.svg'
import TrashIcon from '../Icons/Trash.svg'
import LoadingIcon from '../Icons/Loading.svg'
import API from '../API';
window.cookies = new Cookies()

export default class ListEntry extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}
	async Start() {
		if (this.state.Refreshing)
			return
		this.setState({Refreshing: 'Start'})
		await API('Projects/Start', this.props.project.Name)
		await this.props.list.Refresh()
		this.setState({Refreshing: false})
	}
	async Stop() {
		if (this.state.Refreshing)
			return
		this.setState({Refreshing: 'Stop'})
		await API('Projects/Stop', this.props.project?.Name)
		await this.props.list.Refresh()
		this.setState({Refreshing: false})
	}
	async Clean() {
		if (this.state.Refreshing)
			return
		this.setState({Refreshing: 'Clean'})
		await API('Projects/Clean', this.props.project?.Name)
		await this.props.list.Refresh()
		this.setState({Refreshing: false})
	}
	async Open() {
		if (this.state.Refreshing)
			return
		this.setState({Refreshing: 'Open'})
		const Response = await API('IDE')
		window.cookies.set('vscode-tkn', Response?.Token, { path: '/' })
		this.setState({Refreshing: false})
		window.location.href = '/?folder=/projects/' + this.props.project?.Name
	}
	async Info() {
		window.App.Popup(<pre class="InfoText">{JSON.stringify(this.props.project.Info, null, 2)}</pre>)
	}
	render() {
		const Icons = []
		if (this.props.project.Info)
			Icons.push(<img className="Icon Button Clickable" onClick={()=>this.Info()} src={InfoIcon} />)
		if (this.props.project.Running) {
			Icons.push(<img className="Icon Button Clickable" onClick={()=>this.Stop()} src={this.state.Refreshing=="Stop"?LoadingIcon:StopIcon} />)
		} else {
			Icons.push(<img className="Icon Button Clickable" onClick={()=>this.Start()} src={this.state.Refreshing=="Start"?LoadingIcon:PlayIcon} />)
		}
		if (this.props.project.ContainerExists) {
			Icons.push(<img className="Icon Button Clickable" onClick={()=>this.Clean()} src={this.state.Refreshing=="Clean"?LoadingIcon:TrashIcon} />)
		}
		Icons.push(<img className="Icon Button Clickable" onClick={()=>this.Open()} src={this.state.Refreshing=="Open"?LoadingIcon:OpenIcon} />)
		return (
			<project className="Row">
				<div className="Grow">
					<div className="PublicIP">
						<div>{this.props.project?.PublicIPv4}</div>
						<div>{this.props.project?.PublicIPv6}</div>
					</div>
					<div className="Row">
						<div className="Name Grow">
							{this.props.project?.Name}
							<NavLink to={"/ui/project/"+this.props.project?.Name}><img className="Icon" src={EditIcon} /></NavLink>
						</div>
					</div>
					<pre className="Description">{this.props.project?.Description}</pre>
				</div>
				<div className="Row">
					{Icons}
				</div>
			</project>
		)
	}
}